import { Component, Vue } from 'vue-property-decorator';
import { generateRandomString } from '@/helpers/string.helper';

@Component
export default class VisibleIcon extends Vue {
  get iconId() {
    return `visible-icon-${generateRandomString()}`;
  }
}
